import { IEvent } from '../interfaces';

export class Event<T> implements IEvent<T> {
	private handlers: { (data?: T): void }[] = [];
	public subscribe(handler: { (data?: T): void }) {
		this.handlers.push(handler);
	}
	public unsubscribe(handler: { (data?: T): void }) {
		this.handlers = this.handlers.filter(h => h !== handler);
	}
	public notify(data?: T) {
		this.handlers.slice(0).forEach(h => h(data));
	}
	public unsubscribeAll() {
		this.handlers = [];
	}
}
